class DsfrManager {
  public isWindowDsfrDefined = $state(false);
}

const dsfrManager = new DsfrManager();

export default dsfrManager;
